import _styled from "styled-components";
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, {useCallback, useMemo} from "react";
import {cmpClassName, execFn, getTextColor} from "../../../common/generic-react.functions.js";
import {useReduxWhiteLabelTheme} from "../../../redux/white-label/white-label.hooks.js";
import Spinner from "../loader/loader.component.js";
import {ButtonContainer} from "./button.styles.js";
function Button({
  children,
  block,
  color,
  disabled,
  icon,
  loading,
  rounded = true,
  size = "base",
  text,
  textColor,
  type = "button",
  onClick,
  ...otherProperties
}) {
  const [customTheme] = useReduxWhiteLabelTheme();
  textColor = useMemo(() => color && !textColor ? getTextColor(color, customTheme) : textColor, [color, customTheme, textColor]);
  const basicProps = useMemo(() => ({
    block,
    color,
    disabled,
    rounded,
    text,
    textColor,
    icon,
    type,
    size
  }), [block, size, color, disabled, icon, rounded, text, textColor, type]);
  const content = useCallback(() => {
    if (loading) {
      const sp = /* @__PURE__ */ React.createElement(Spinner, {
        color,
        size
      });
      return children ? /* @__PURE__ */ React.createElement(React.Fragment, null, sp, /* @__PURE__ */ React.createElement(_StyledSpan, null, children)) : sp;
    } else {
      return children;
    }
  }, [children, color, loading, size]);
  return /* @__PURE__ */ React.createElement(ButtonContainer, _extends({
    className: cmpClassName("button"),
    role: "button"
  }, otherProperties, basicProps, {
    onClick: () => execFn(!disabled && onClick)
  }), content());
}
export default /* @__PURE__ */ React.memo(Button);
var _StyledSpan = _styled("span").withConfig({
  displayName: "buttoncomponent___StyledSpan",
  componentId: "sc-1gqjrht-0"
})({
  paddingLeft: "0.5rem"
});
